
export default {
  props: {
    errorCode: {
      type: String,
      default: null
    }
  }
}
